import React from 'react';
import './style.scss';
interface Item {
    title: string;
    subItems: SubItem[];
}
interface SubItem {
    value: string | number;
    conditionalValue?: number;
    iconType: string;
    iconName: string;
}
interface CardActionProps {
    title: string;
    items: Item[];
    actionLabel: string;
    handleAction: () => void;
}

const CardAction: React.FC<CardActionProps> = ({ title, items, actionLabel, handleAction }: CardActionProps) => {
    return (
        <div className="card-action">
            <h3>{title}</h3>
            <div>
                {items.map((item, index) => (
                    <div key={index}>
                        <h4>{item.title}</h4>
                        {item.subItems.map((subItem, subIndex) => (
                            <h2 key={subIndex}>
                                <i className={`${subItem.iconType} align-middle`}>{subItem.iconName}</i>
                                {(subItem.conditionalValue === 0 && (
                                    <span className="conditional-unlimited-value align-middle">{subItem.value}</span>
                                )) || <span className="align-middle">{subItem.value}</span>}
                                {subItem.conditionalValue ? <span className="conditional-item-value">{`/${subItem.conditionalValue}`}</span> : null}
                            </h2>
                        ))}
                    </div>
                ))}
            </div>
            <button className="btn btn-primary new-item-button" onClick={handleAction} type="button">
                {actionLabel}
            </button>
        </div>
    );
};

export default CardAction;
